exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".course-detail-page[data-v-446085c6]{background:#fafafa!important}", ""]);

// exports
